export default {
  data() {
    return {
      // eslint-disable-next-line
      companyStructure: [
        "Company",
        "Partnership",
        "Sole Trader",
        "Trust"
      ],
      companyArea: [
        "Accommodation and Food",
        "Admin and Support",
        "Agriculture, Forestry and Fishing",
        "Arts and Recreation",
        "Construction",
        "Education and Training",
        "Finanical and Insurance",
        "Health Care and Social",
        "Information and Telecommunications",
        "Manufacturing",
        "Mining",
        "Professional and Technical",
        "Rental, Hiring and Real Estate",
        "Retail and Wholesale Trade",
        "Specialist Services",
        "Tourism",
        "Transport, Postal and Warehousing",
        "Utilities and Infrastructure"
      ],
      // eslint-disable-next-line
      companySearchPrivacy: [
        "Public",
        "Private"
      ],
      companyAuthLevelDataLimit: ["2", "3", "4", "5"]
    };
  }
};
